import { SvgIcon } from '@mui/material';
import { SMPalette } from '@nx-smartmonkey/ui';

interface TimeWindowsProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function TimeWindows({ color = SMPalette.grey1, style = {} }: TimeWindowsProps) {
  return (
    <SvgIcon viewBox="0 0 13.17 13.26" style={{ width: `24px`, ...style }}>
      <g>
        <path
          fill={color}
          d="m6.59,13.12C3.01,13.12.1,10.21.1,6.63S3.01.15,6.59.15s6.49,2.91,6.49,6.49-2.91,6.49-6.49,6.49Zm0-11.97C3.56,1.15,1.1,3.61,1.1,6.63s2.46,5.49,5.49,5.49,5.49-2.46,5.49-5.49S9.61,1.15,6.59,1.15Z"
        />
        <path
          fill={color}
          d="m8.98,8.33c-.08,0-.15-.02-.22-.05l-2.39-1.2c-.17-.08-.28-.26-.28-.45v-3.59c0-.28.22-.5.5-.5s.5.22.5.5v3.28l2.12,1.06c.25.12.35.42.22.67-.09.17-.26.28-.45.28Z"
        />
      </g>
    </SvgIcon>
  );
}
